export default __webpack_public_path__ + "7be4b12198929348ef9c6c1a35fbb432.png";